<template>
    <div id="app" :class="projectTheme === 'theme-purple'? 'theme-purple' : 'theme-default'">
        <div class="mala-content clearfix" :class="{
        'mala-trans': $route.meta.keepAlive === 3,
        'mala-allscreen': $route.meta.keepAlive === 4,
        'mala-knowlege bg07': $route.meta.keepAlive === 5,
      }">
            <!-- 头部导航 -->
            <Topmenu v-if="$route.meta.topShow"></Topmenu>
            <div class="content clearfix" ref="child" :class="!$route.meta.topShow ? '' : 'w12'">
                <router-view></router-view>
            </div>
            <Footer v-if="$route.meta.footShow"></Footer>
        </div>
        <!-- 提示弹框 -->
        <Dialog ref="tipsModal" type="alert">
            <div slot="mdBox">
                <p class="ac" v-html="tipsHtml"></p>
            </div>
        </Dialog>
        <!-- loading -->
        <div class="loadBox ac" v-show="showLoad">
            <div class="loadCont">
                <img src="/static/images/loading1.gif" />
                <p>{{ loadHtml }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import Dialog from "@/components/dialog";
import Topmenu from "@/components/topMenu";
import Footer from "@/components/footer";
export default {
    components: { Topmenu, Dialog, Footer },
    name: "App",
    data() {
        return {
            projectTheme: "theme-purple",
            realmName: "", //域名
            tipsHtml: "", //提示语句
            userName: "", //用户昵称
            timeSection: "365",
            isSignin: false,
            showLoad: false,
            loadHtml: "正在加载...",
            hotKey: [],
        };
    },
    created() {
        this.getMapjosn();
    },
    mounted() {
        let that = this;
        //that.$nextTick(()=> {
        //验证登录信息

        let host = window.location.host;
        if (that.$route.meta.title) {
            document.title = that.$route.meta.title;
        }

        // 获取cookie setview
        let setview = this.getCookie("setview");
        console.log(setview)
        // 如果setview < 0   则设置为紫色主题
        if (setview < 0) {
          that.projectTheme = "theme-purple"
        } else {
          that.projectTheme = "theme-default"
        }

        if (that.projectTheme === "theme-purple") {
            let root = document.documentElement;
            root.style.setProperty("--body-bg", "#f5f2ff");
            root.style.setProperty("--body-color", "#222");
            root.style.setProperty("--header-bg", "#fff");
            root.style.setProperty("--header-color", "#000");
            root.style.setProperty("--bgfff", "#fff");
            root.style.setProperty("--cr00", "#000");
            root.style.setProperty("--type-li", "#f2f2f2");
            root.style.setProperty("--left-bg", "#fff");
            root.style.setProperty("--type-li-cur", "#f0e6ff");
            root.style.setProperty("--input-bg", "#fff");
            root.style.setProperty("--btnMore", "#f0e6ff");
            root.style.setProperty("--corm-cur-bg", "#e6d9ff");
            root.style.setProperty("--eventLine-bg", "#f7fafc");
            root.style.setProperty("--cr5e", "#5e5e5e");
            root.style.setProperty("--region-header-bg", "#f0e6ff");
            root.style.setProperty("--corm-color", "#7F33D6");
        }

        if (!this.$route.query.api_secret) {
            //为了放开详情页，有这个参数不进入热点参考
            if (host === "hot.nybkz.com") {
                //线上
                let cooke = document.cookie.indexOf("_gsdataCL");
                if (cooke != -1) {
                    that.isSignin = true;
                } else {
                    if (that.$route.meta.requireAuth) {
                        that.showLoad = false;
                        //that.$router.push({ path:'/login'});
                        window.location.href =
                            "https://u1.nybkz.com/member/login?url=http://" +
                            host +
                            "/";
                    }
                }
            }
            that.hotKeyWords();
        } else {
            let root = document.documentElement;
            root.style.setProperty("--body-bg", "#000");
            root.style.setProperty("--body-color", "#fff");
            root.style.setProperty("--header-bg", "#000");
            root.style.setProperty("--header-color", "#fff");
            root.style.setProperty("--bgfff", "#111d35");
            root.style.setProperty("--cr00", "#fff");
            root.style.setProperty("--type-li", "#333");
            root.style.setProperty("--left-bg", "#111d35");
            root.style.setProperty("--type-li-cur", "#555");
            root.style.setProperty("--input-bg", "rgba(255,255,255,0)");
            root.style.setProperty("--btnMore", "#111d35");
            root.style.setProperty("--corm-cur-bg", "#333");
            root.style.setProperty("--eventLine-bg", "#333");
            root.style.setProperty("--cr5e", "#fff");
            root.style.setProperty("--cr77", "#fff");
            root.style.setProperty("--region-header-bg", "#333");
            root.style.setProperty("--corm-color", "#fff");
        }
    },
    methods: {
      getCookie(name) {
        let value = "; " + document.cookie;
        let parts = value.split("; " + name + "=");
        if (parts.length === 2) return parts.pop().split(";").shift();
      },
      getMapjosn() {
            let that = this;
            if (!sessionStorage.getItem("city2")) {
                that.$api.getJson(
                    "https://gsdata-img1.oss-cn-hangzhou.aliyuncs.com/gsdata/gsdata_doc/common/js/city/region2.json",
                    (r) => {
                        let guoji = {
                            id: "35",
                            pid: "0",
                            province_id: "35",
                            full_name: "国际",
                            short_name: "国际",
                            other_name: "国际",
                            pinyin: "",
                            short_pinyin: "",
                            code: "830000",
                            level: "1",
                            sons: [
                                {
                                    id: "35",
                                    pid: "0",
                                    province_id: "35",
                                    full_name: "国际",
                                    short_name: "国际",
                                    other_name: "国际",
                                    pinyin: "",
                                    short_pinyin: "",
                                    code: "830000",
                                    level: "1",
                                },
                            ],
                        };

                        r.push(guoji);
                        sessionStorage.setItem("city2", JSON.stringify(r));
                    }
                );
            }
        },
        hotKeyWords() {
            let that = this;
            that.hotKey = [];
            that.$api.get("news/index/spread-number-words", null, (r) => {
                that.returnCode(r, function () {
                    r.data.forEach((ele) => {
                        let tmp = {};
                        tmp.name = ele;
                        tmp.isClick = false;
                        that.hotKey.push(tmp);
                    });
                });

            });
            //  that.$api.get('https://gsdata-img1.oss-cn-hangzhou.aliyuncs.com/gsdata/gsdata_doc/common/js/city/region.json',null,r=>{
            //     console.log(JSON.parse(r))
            // });
        },
        loadModal(isShow, txt) {
            let that = this;
            if (txt != "") {
                that.loadHtml = txt;
            }
            that.showLoad = isShow;
        },
        // alert提示
        alertTips(text) {
            this.tipsHtml = text;
            this.$refs.tipsModal.showMaskFun();
        },
        // code判断
        returnCode(data, callback) {
            let code = data.code;
            if (code === 10000) {
                callback();
            } else {
                if (code === 10003) {
                    //未登录
                    //that.$router.push({ path:'/login'});
                    //window.location.href= data.data;
                    let host = window.location.host;
                    window.location.href =
                        "https://u1.nybkz.com/member/login?url=http://" +
                        host +
                        "/";
                } else {
                    if (data.msg != undefined) {
                        this.$utils.alertText(data.msg);
                    }
                }
                this.showLoad = false;
                this.$refs.child.isDisable = false;
            }
        },
    },
};
</script>

<style>
@import "./style/animate.css";
@import "./style/base.css";
@import "./style/style.css";

.theme-purple {
    --primary-color: #7F33D6;
    --primary-light: #a366e6;
    --primary-dark: #6b2ab8;
}
.theme-purple a:hover,
.theme-purple a:active {
    color: var(--primary-color);
}
.theme-purple .color-blue {
    color: var(--primary-color);
}
.theme-purple .btn-bdblue {
    border-color: var(--primary-color);
    color: var(--primary-color);
}
.theme-purple .btn-blue {
    background: var(--primary-color);
}
.theme-purple .btn-lightblue {
    background: rgba(127, 51, 214, 0.1);
    color: var(--primary-color);
}
.theme-purple .btn-jbblue {
    background: linear-gradient(to right, var(--primary-color), var(--primary-light));
}
.theme-purple .navLi {
    color: var(--primary-color);
    border-color: var(--primary-color);
}
.theme-purple .navLi.curr {
    background: var(--primary-color);
    color: #fff;
}
.theme-purple .grid-header .title:before {
    background-color: var(--primary-color);
}
.theme-purple .checkbox-group .checkbox-box.curr {
    color: var(--primary-color);
}
.theme-purple .corm .element.curr {
    border-color: var(--primary-color);
    color: var(--primary-color);
}
.theme-purple .typeLi li.cur,
.theme-purple .typeLi li:hover {
    color: var(--primary-color);
    background-color: var(--type-li-cur);
}
.theme-purple .line .in {
    background: linear-gradient(to right, var(--primary-color), var(--primary-light));
}
.theme-purple .hotKeyLi {
    border-color: var(--primary-color);
    color: var(--primary-color);
    background-color: rgba(127, 51, 214, 0.17);
}
.theme-purple .hotKeyLi:hover,
.theme-purple .hotKeyLi.cur {
    background-color: var(--primary-color);
    color: #fff;
}
.theme-purple .sign-blue {
    background: var(--primary-color);
}
.theme-purple .drop-down .option li:hover {
    color: var(--primary-color);
}
.theme-purple .headerWrap  .drop{
    color: #fff !important;
}

.theme-purple .headerWrap {
    box-shadow: 0 0 2px var(--primary-color);
}
.theme-purple .header {
    background: var(--primary-color);
}
.theme-purple .nav-menu li a {
    color: #fff;
}
.theme-purple .nav-menu li a:hover {
    color: #fff;
    opacity: 0.85;
}
.theme-purple .nav-menu li .router-link-active:not(.active-none) {
    border-bottom: 3px solid #fff;
    color: #fff;
}
.theme-purple .topLi {
    color: #fff;
}
.theme-purple .nav-menu li .beta {
    background-color: #fff;
    color: var(--primary-color);
}
.theme-purple .cr27 {
    color: #7F33D6;
}
.theme-purple .search-btn {
    background-color: #7F33D6;
}
</style>



// WEBPACK FOOTER //
// src/App.vue